import { configureStore } from '@reduxjs/toolkit';
import dataReducer from "../slice/dataSlice";
import dateReducer from "../slice/dateSlice";
import pageReducer from "../slice/pageSlice";
import searchReducer from "../slice/searchSlice";
import authReducer from "../slice/authSlice";
import codeReducer from "../slice/codeSlice";
import inputReducer from "../slice/inputSlice";
import apiReducer from "../slice/apiSlice";
import chatReducer from "../slice/chatSlice";
import openerReducer from "../slice/opnerSlice";
import searchPagingReducer from "../slice/searchPagingSlice";
import statusReducer from "../slice/statusSlice";
import contentReducer from "../slice/contentSlice";
import aiCacheReducer from "../slice/aiCacheSlice";
import excelGridReducer from "../slice/excelGridSlice";


export const store = configureStore({
    reducer: {
        data: dataReducer,
        date: dateReducer,
        opener: openerReducer,
        page: pageReducer,
        search: searchReducer,
        auth: authReducer,
        code: codeReducer,
        input: inputReducer,
        api: apiReducer,
        chat: chatReducer,
        searchPaging: searchPagingReducer,
        status: statusReducer,
        content: contentReducer,
        aiCache: aiCacheReducer,
        excelGrid: excelGridReducer,
    },
});

export default store;
